// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Ekq","newExpiryDate":"styles_newExpiryDate__10KgL","footer":"styles_footer__2HlGi"};